import React from "react";

import Hero from "./components/BirthPlanHomepage/Hero";
import Introduction from "./components/BirthPlanHomepage/Introduction";
import Instructions from "./components/BirthPlanHomepage/Instructions";
import Footer from "./components/BirthPlanHomepage/Footer";
import MoreInfo from "./components/BirthPlanHomepage/MoreInfo";

export default function BirthPlanHomepage() {
  return (
    <>
      <Hero />
      <Introduction />
      <Instructions />
      <MoreInfo />
      <Footer />
    </>
  );
}
